// Pages
import { licenseGuard } from '@/router/guards'
import RouterView from '@/components/pages/RouterView/Router'

import Patients from '@/components/pages/Patients/Patients.vue'
import Patient from '@/components/pages/Patients/Patient.vue'
import AddPatient from '@/components/pages/Patients/AddPatient.vue'
import EditPatient from '@/components/pages/Patients/EditPatient.vue'
import PatientConsent from '@/components/pages/Patients/PatientConsent.vue'
import AddPatientsWithOperations from '@/components/pages/Patients/AddPatientsWithOperations.vue'
import AddPatientPreop from '@/components/pages/Patients/AddPatientPreop.vue'

import PatientQuestionnaires from '@/components/pages/Patients/PatientQuestionnaires'
import PatientQuestionnaire from '@/components/pages/Questionnaire/Questionnaire'

export default {
  path: '/patients',
  component: RouterView,
  meta: {requiresAuth: true},
  children: [
    {
      path: '',
      name: 'all-patients',
      component: Patients,
      meta: {breadcrumb: 'My Patients'}
    },
    {
      path: 'add-patient',
      name: 'add-patient',
      component: AddPatient,
      meta: {breadcrumb: 'Add New Patient'},
      //beforeEnter: licenseGuard
    },
    {
      path: 'add-patients',
      name: 'add-patients',
      component: AddPatientsWithOperations,
      meta: {breadcrumb: 'Add Patients & Surgeries'},
      //beforeEnter: licenseGuard
    },
    {
      path: 'add-patient-preop',
      name: 'add-patient-preop',
      component: AddPatientPreop,
      meta: {breadcrumb: 'Add Patient & Pre-Op'},
      children: [
        {
          name: 'preop-patient-questionnaire',
          path: ':id/questionnaire/:questionnaireId',
          component: PatientQuestionnaire,
          props: true
        },
      ]
    },
    {
      path: 'patient-consent',
      name: 'patient-consent',
      component: PatientConsent,
      meta: {breadcrumb: 'Patient Consent'},
    },
    {
      path: ':id',
      component: RouterView,
      children: [
        {
          path: '',
          component: Patient,
          props: true,
          name: 'view-patient'
        },
        {
          path: 'questionnaires',
          component: PatientQuestionnaires,
          props: true,
          name: 'patient-questionnaires'
        },
        {
          path: 'questionnaire/:questionnaireId',
          component: PatientQuestionnaire,
          props: true,
          name: 'patient-questionnaire'
        },
        {
          path: 'edit',
          component: EditPatient,
          name: 'edit-patient',
          props: true,
          meta: {breadcrumb: 'Edit'},
          //beforeEnter: licenseGuard
        }
      ]
    }
  ]
}



// WEBPACK FOOTER //
// ./src/router/routes/patients.js